import update from 'immutability-helper';
import * as types from './types';

const initialState = {};
const switchMap = {};

switchMap[types.INIT] = state => update(state, {
  $set: initialState,
});

switchMap[types.SETUP_DIMENSION] = (state, action) => {
  const { dimension, dimensionStore } = action;
  return update(state, {
    [dimension]: { $set: dimensionStore },
  });
}

switchMap[types.UNSET_DIMENSION] = (state, action) => {
  return update(state, {
    $unset: [action.dimension],
  });
}

switchMap[types.SET_RESPONSE] = (state, action) => {
  const { dimension, response, errorMsg } = action;
  return update(state, {
    [dimension]: {
      $merge: {
        response,
        isFetching: false,
        errorCode: 0,
        errorMsg,
        invalid: false,
      },
    }
  });
}

export default (state = initialState, action) => (switchMap[action.type]
  ? switchMap[action.type](state, action) : state);
